import React from 'react'

export const CheckingAuth = () => {
  return (
    <div>Cargando</div>
  )
}
